// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#father[data-v-6447faf0]{position:fixed;right:18px;bottom:18px;z-index:999}#zc-sdk-btn[data-v-6447faf0]{width:32px;height:32px;border-radius:50%;background:var(--color-help-bg);color:var(--color-help-icon);display:flex;justify-content:center;align-items:center;box-shadow:0 2px 4px rgba(0,0,0,.16);border:1px solid var(--m-color-gray-400)}.zc-sdk-btn-client[data-v-6447faf0]{display:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
